import { State } from '../state';

export const accountancy: State = {
    url: 'accountancy'
};

export const newAccountancy: State = {
    url: 'accountancy/new',
    parent: accountancy
};
export const editAccountancy: State = {
    url: 'accountancy/edit',
    parent: accountancy
};
